import React from 'react'
import { withRouter } from 'react-router-dom'

import CategoryFeatureEditor from '../components/category-feature/editor'
import CategoryFeatureList from '../components/category-feature/list'

class CategoryFeaturePage extends React.Component {
    render(){

        const { categoryFeatureId } = this.props.match.params

        if( categoryFeatureId ) {
            return (
                <CategoryFeatureEditor
                    categoryFeatureId={categoryFeatureId}
                />
            )
        }

        return (
            <CategoryFeatureList/>
        )
    }
}

export default withRouter(CategoryFeaturePage)


// WEBPACK FOOTER //
// ./src/containers/category-feature-page.js